/**
 * Google Tag Manager container id. Kept in sync with the `<noscript>` fallback
 * still hardcoded in `index.html` (which cannot read JS config).
 */
export const GTM_CONTAINER_ID = 'GTM-MTZDFCVK';
